module.exports = {"TXTWCL_Request_successful":{"id":"TXTWCL_Request_successful","defaultMessage":"Požadavek byl úspěšný"}}